// extracted by mini-css-extract-plugin
export default {"root":"IconCustomClose_root__Q7rFS"};